import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type ProductSearchResultItemGenericLabelProps =
  ComponentPropsWithoutRef<'button'> & {
    hasBorder?: boolean
  }

export const ProductSearchResultItemGenericLabel: FC<
  ProductSearchResultItemGenericLabelProps
> = ({ className, hasBorder = true, ...rest }) => (
  <button
    className={clsx(
      className,
      hasBorder && 'border px-3 py-1',
      !hasBorder && 'px-2.5 py-1.5',
      'flex items-center whitespace-nowrap rounded-full text-xs',
      !rest.onClick && 'cursor-default',
    )}
    type="button"
    {...rest}
  />
)
